export default {
  state: {
    omtId: localStorage.getItem('omtId') || undefined,
    adReferrer: localStorage.getItem('adReferrer') || undefined,
    fullReferrer: localStorage.getItem('fullReferrer') || undefined,
  },
  mutations: {
    setOmtId(state, omtId) {
      localStorage.setItem('omtId', omtId);
      state.omtId = omtId;
    },
    setAdReferrer(state, adReferrer) {
      localStorage.setItem('adReferrer', adReferrer);
      state.adReferrer = adReferrer;
    },
    setFullReferrer(state, fullReferrer) {
      localStorage.setItem('fullReferrer', fullReferrer);
      state.fullReferrer = fullReferrer;
    },
  },
  actions: {
    setOmtId({ commit }, omtId) {
      commit('setOmtId', omtId);
    },
    setAdReferrer({ commit }, adReferrer) {
      commit('setAdReferrer', adReferrer);
    },
    setFullReferrer({ commit }, fullReferrer) {
      commit('setFullReferrer', fullReferrer);
    },
  },
  getters: {
    omtId: state => state.omtId,
    adReferrer: state => state.adReferrer,
    fullReferrer: state => state.fullReferrer,
  },
};
